import * as yup from 'yup';

const ExportSpreadsheetSchema = yup.object().shape({
  start_date: yup.date().required('O campo Data Inicial é obrigatório').nullable(),
  end_date: yup.date().required('O campo Data Final é obrigatório').nullable(),
  recipients: yup.array().min(1, 'Selecione pelo menos um usuário para receber o back-up.'),
});

export default ExportSpreadsheetSchema;
